import { render } from "./Admin_Dashbord.vue?vue&type=template&id=19254369"
import script from "./Admin_Dashbord.vue?vue&type=script&lang=js"
export * from "./Admin_Dashbord.vue?vue&type=script&lang=js"

import "./Admin_Dashbord.vue?vue&type=style&index=0&id=19254369&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__